// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "QuestionCreateDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { QuestionResponseGenShape } from "./question-response.gen";

export const QuestionCreateDtoGenShape = z.strictObject({
  libraryId: z.string(),
  treeId: z.string(),
  text: z.string(),
  name: z.string(),
  tagId: z.string().nullable().default(null),
  slug: z.string(),
  info: z.string(),
  responses: z.array(QuestionResponseGenShape),
  entryPoint: z.boolean(),
  variableId: z.string().nullable().default(null),
  relatedQuestionId: z.string().nullable().default(null),
});
